import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Foundation Quarter',
  range: 'Weeks 1–12 · 36 sessions',
  promise: 'Teach the patterns, build the habit, lift the first real loads.',
  badge: 'bg-gold-deep',
  contents: ['Foundation block: squat, hinge, push, pull, lunge, core', 'Strength Block 1: 5×5 at 70% up to 5×3 at 80%', 'Conditioning block: AMRAPs, EMOMs, Tabatas, a chipper, a partner WOD', 'Week 1 baseline test — your clients re-test it in Week 52', '3 deload weeks already written in']
}, {
  number: '02',
  title: 'The Build Quarter',
  range: 'Weeks 13–24 · 36 sessions',
  promise: 'Mix strength and engine, then add power and speed.',
  badge: 'bg-crimson',
  contents: ['Hybrid block: strength and conditioning in the same class', 'Power & Speed block', 'Metabolic Conditioning block', 'Deload week closing every block']
}, {
  number: '03',
  title: 'The Engine Quarter',
  range: 'Weeks 25–36 · 36 sessions',
  promise: 'Longer efforts, heavier second strength block, more group energy.',
  badge: 'bg-[#2F6FB5]',
  contents: ['Endurance Circuits block', 'Strength Block 2', 'Team Challenges block', 'Deload week closing every block']
}, {
  number: '04',
  title: 'The Peak Quarter',
  range: 'Weeks 37–52 · 48 sessions',
  promise: 'Partner work, intervals, and a year-end benchmark to prove progress.',
  badge: 'bg-[#1C7A45]',
  contents: ['Partner Workouts block', 'High-Intensity Intervals block', 'Strength + Conditioning Blend block', 'Maintenance + Year-End Benchmark: re-test Week 1']
}, {
  number: '05',
  title: 'The Adaptation Matrix',
  range: 'Swaps for every session',
  promise: 'Rain, a small space, missing gear, a brand-new client? Keep the pattern, swap the movement.',
  badge: 'bg-[#5B2AA5]',
  flag: 'Core value',
  contents: ['The 9 movement patterns every exercise belongs to', 'Equipment swap tables: kettlebell, band, sandbag, backpack, bodyweight', 'Load equivalences in kg and lb', 'Regressions and progressions by level', 'The golden rule: the clock never changes']
}, {
  number: '06',
  title: 'The Coaching & Retention Playbook',
  range: 'How to lead it and keep them coming',
  promise: 'The calendar tells you what to teach. This shows you how to lead it.',
  badge: 'bg-[#0E7490]',
  contents: ['Coaching presence: the first 60 seconds, the 3-part demo', 'Class scripts to use word-for-word', 'Cue library for mid-class', 'Monthly retention systems', 'Business tools: attendance tracker and block calendar']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-navy" data-id="element-227" data-mp="2h6vosomx1qc5">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-228" data-mp="wm8ogl3hltyg">
        <div className="text-center" data-id="element-229" data-mp="11ksb6npwn9rv">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-230" data-mp="11jqpzqf6d6wf">
            The complete playbook
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-231" data-mp="1alzw843eue40">
            Inside the box set — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-232" data-mp="iukfgqojbllp">
            Four dated quarters that cover every class of the year, plus the two
            playbooks that make them work in your space, with your people.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-233" data-mp="rpi95zzib2e3">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-navy-card p-6 shadow-card ${tome.flag ? 'border-gold ring-1 ring-gold' : 'border-navy-line'}`} data-id="element-234" data-mp="3r92qn19rvh9j">
              <div className="flex items-center gap-2.5" data-id="element-235" data-mp="37a3um39owc51">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg text-white ${tome.badge}`} data-id="element-236" data-mp="3lxf501u4xq3k">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-237" data-mp="3uxkcebzbwohq">
                  Volume {tome.number}
                </span>
                {tome.flag && <span className="ml-auto rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-238" data-mp="8rf2zw0l9a8h">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-239" data-mp="2ajbdr3exmg27">
                {tome.title}
              </h3>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-gold-deep" data-id="element-240" data-mp="25li8qdpd7s3i">
                {tome.range}
              </p>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-241" data-mp="q0zjfko2ry8n">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-navy-line pt-4" data-id="element-242" data-mp="bbl6y3p7d0p1">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-243" data-mp="g9wgedbl596q">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-244" data-mp="2b55ezs0s3mt" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}